module.exports = __webpack_public_path__ + "media/about/Located-4d7f148d.png";